const _listeners = [];
let _index = 0;

export function broadcast(eventName, data) {
    _listeners.forEach(eventHandler => {
       if(eventHandler.eventName !== eventName) return;
       eventHandler.callback(data);
    });
}

export function listen(eventName, callback) {
    _listeners.push({
        eventName,
        callback,
        index: _index++
    });
}

// TODO: add off function
